module.exports = __webpack_public_path__ + "img/rubin_benefit_08_doctor.62d6051b.svg";